import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

/** Reusable FAQ accordion styled to the Renova brand. */
export default function FaqAccordion({ faqs = [], testIdPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={`${testIdPrefix}-accordion`}>
      {faqs.map((f, i) => (
        <AccordionItem
          key={i}
          value={`item-${i}`}
          className="border-b border-[#1E2A44]/12"
        >
          <AccordionTrigger
            className="!py-6 !text-lg font-serif !font-normal text-[#1E2A44] hover:!no-underline [&>svg]:text-[#C8A96A] [&>svg]:h-5 [&>svg]:w-5"
            data-testid={`${testIdPrefix}-q-${i}`}
          >
            {f.question}
          </AccordionTrigger>
          <AccordionContent className="!pb-6 text-[15px] leading-relaxed text-[#85827D] max-w-3xl">
            {f.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
